import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import classNames from 'classnames'

import {HashTag, DeepLink} from '../../services/hashtag'

const KEY_ENTER = 13

export class QuickChat extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            message: '',
            active: false
        }

        _.bindAll(this,
            'updateMessage',
            'onKeyDown',
            'handleSubmit',
            'toggleShow'
        )

    // this.updateMessage = this.updateMessage.bind(this)
    }

    toggleShow() {
        if (this.state.active) {
            this.setState({active: false})
        } else {
            this.setState({active: true})
        }
    }

    updateMessage(evt) {
        this.setState({
            message: evt.target.value
        })
    }

    onKeyDown(evt) {
        let keyHandlers = {}
        keyHandlers[KEY_ENTER] = this.handleSubmit
        var handler = _.get(keyHandlers, evt.which)

        if (handler) {
            evt.preventDefault()
            handler()
        }
    }

    handleSubmit() {
        if (!this.state.message) {
            return
        } else {
            let legHasDestination = this.props.leg.getIn(['destination', 'title'])
            let hashTitle
            if (legHasDestination) {
                hashTitle = _.camelCase(this.props.leg.getIn(['destination', 'title']))
            } else {
                let day = this.props.leg.getIn(['properties', 'start']) + 1
                hashTitle = _.camelCase('day' + day.toString())
            }

            if (this.props.targetItem.get('name')) {
                hashTitle += ': ' + this.props.targetItem.get('name')
            }

            let deepLink = DeepLink.new(DeepLink.segment.activeItinerary(), DeepLink.segment.leg(this.props.leg)) // default

            switch (this.props.targetItemType) {
                case 'accommodation':
                    deepLink = DeepLink.new(DeepLink.segment.activeItinerary(), DeepLink.segment.leg(this.props.leg), DeepLink.segment.accommodation(this.props.targetItem))
                    break
                case 'activity':
                    deepLink = DeepLink.new(DeepLink.segment.activeItinerary(), DeepLink.segment.leg(this.props.leg), DeepLink.segment.activity(this.props.targetItem))
                    break
            }

            let hashTag = HashTag.new(hashTitle, deepLink).serialize()

            let parseMentions = []
            let lunaIndex = this.state.message.toLowerCase().indexOf('@luna')
            if (lunaIndex >= 0) {
                parseMentions = [
                    {
                        handle: '@luna',
                        mention_index: lunaIndex,
                        at_luna: true
                    }
                ]
            }

            this.props.onChatSend(
                this.props.tripGuid,
                this.state.message,
                this.props.currentUser.guid,
                hashTag,
                parseMentions,
                moment.utc()
            )
            this.setState({
                message: ''
            })
        }
    }

    render() {
    // prevent the event from triggering activateLeg
        let stopProp = (event) => {
            event.stopPropagation()
        }

        let classes = classNames(
            'quickchat-container',
            {'active': this.state.active}
        )


        return (
            <div
        className={classes}
        onClick={stopProp}>
                <i className="icon-chat" onClick={() => {this.toggleShow()}}/>
                <div className="quickchat-wrapper">
                    <i className="icon-close" onClick={() => {this.toggleShow()}}/>
                    <div className="quickchat-window">
                        <textarea
                name="chat-message"
                placeholder="Start typing here (Enter to submit)"
                value={this.state.message}
                onChange={this.updateMessage}
                onKeyDown={this.onKeyDown}/>
                    </div>
                </div>
            </div>
        )
    }
}


// <input
//   type="text"
//   placeholder="Enter message here"
//   value={this.state.message}
//   onChange={this.updateMessage}
// />